<template>
  <div v-if="isVerificationEditor">
    <div v-if="!isBusy && (!model || model?.length === 0)" class="alert alert-warning">
      No activity logs
    </div>
    <card v-if="model && model.length > 0">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" style="width: 180px">Date</th>
            <th scope="col">User</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody v-for="log in model" :key="log.id">
          <tr>
            <td>{{ $helpers.dateTimeString(log.createdAt) }}</td>
            <td>{{ log.username }}</td>
            <td>{{ log.description }}</td>
          </tr>
        </tbody>
      </table>
    </card>
  </div>
</template>

<script>
import { Card } from '@trustmark-2005-ltd/trustmark-shared-components';

export default {
  name: 'SchemeBusinessVerificationActivityLogs',
  components: {
    Card,
  },
  computed: {
    currentAccount() {
      return this.$store.state.auth.account;
    },
    isVerificationEditor() {
      return this.currentAccount && this.currentAccount.roles
        ? this.currentAccount.roles.includes('VerificationEditor')
        : false;
    },
    model() {
      return this.$store.state.schemeBusiness.verificationActivityLog;
    },
    isBusy() {
      return this.$store.state.isBusy;
    },
  },
  async mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    this.$store.commit('schemeBusiness/clearVerificationActivityLog');
    if (!this.model || this.model.length === 0) {
      await this.$store.dispatch('schemeBusiness/getAllVerificationActivityLog', {
        schemeBusinessId: this.$route.params.schemeBusinessId,
      });
    }
  },
};
</script>
